import React from 'react';
import { withStyles } from "@mui/styles";
import { Box } from '@mui/material';
import MainAppBar from '../app-bar/main/MainAppBar';
import SecondaryAppBar from '../app-bar/secondary/SecondaryAppBar';

const styles = {
  root: {},
};

function Header(props) {
  return (
    <div id="appHeader" className={props.classes.root}>
      <MainAppBar
        isRightDrawerOpen={props.isRightDrawerOpen}
        toggleRightDrawer={props.toggleRightDrawer}
        openContactDialog={props.openContactDialog}
        openHelpDialog={props.openHelpDialog}
      />
      <Box sx={{ display: { xs: 'none', md: 'block' }}}>
        <SecondaryAppBar />
      </Box>
    </div>
  );
}

export default withStyles(styles)(Header);
